import { useEffect } from "react";
import isEmpty from "lodash.isempty";
import { useWatch, useFormState, useFormContext } from "react-hook-form";

import { useAuth } from "providers/Auth";
import { useLoading } from "providers/Loading";
import { useTimer } from "hooks/useTimer";

import * as ga from "methods/ga";
import * as Client from "api/client";
import AnnotationItem from "../AnnotationItem";
import { verifyState } from "config/const";
import { BlackButton } from "../Styled";
import moment from "moment";
import { useToast } from "providers/Toast";

function CountDown({ endtime = 0, setTimerFinish }) {
  const timer = useTimer(endtime);
  if (timer <= 0) {
    setTimerFinish(timer);
    return <div style={{ height: "19.91px" }} />;
  }

  const remainTime = Math.floor(timer / 60) + ":" + Math.floor(timer % 60);
  return `驗證碼 倒數${remainTime}`;
}

function getHelperText({
  verifiedToken,
  status,
  verifyTimeout,
  setTimerFinish,
}) {
  if (verifiedToken) return "驗證完成";
  switch (status) {
    case verifyState.UNVERIFY:
      return "請點選發送驗證碼";
    case verifyState.VERIFYING:
    default:
      if (verifyTimeout)
        return (
          <CountDown endtime={verifyTimeout} setTimerFinish={setTimerFinish} />
        );
      else return <div style={{ height: "19.91px" }} />;
  }
}
export default function Phone({ item, defaultValue }) {
  const { withLoading } = useLoading();
  const { auth, profile } = useAuth();
  const { danger } = useToast();

  const sendVerify = (phone) => Client.sendPhoneVerify(auth.userId, phone);

  const phone = useWatch({ name: "phone", defaultValue });
  const verifiedToken = useWatch({ name: "verifiedToken" });
  const status = useWatch({
    name: "phoneVerifyStatus",
    defaultValue: verifyState.VERIFIED,
  });
  const verifyTimeout = useWatch({ name: "verifyTimeout" });

  const { setValue } = useFormContext();
  const { errors } = useFormState({ name: "phone", exact: true });
  const validPhone = phone && isEmpty(errors["phone"]);
  const isError =
    !isEmpty(errors) && (!phone || !phone.match(/^(09)[0-9]{8}$/));

  const setTimerFinish = (value) => {
    if (verifyState.VERIFYING === status && value <= 0)
      setValue("verifyTimeout", value);

    if (verifyState.VERIFIED !== status)
      setValue("phoneVerifyStatus", verifyState.UNVERIFY);
  };

  const verifyHelperText = getHelperText({
    verifiedToken,
    status,
    verifyTimeout,
    setTimerFinish,
  });

  const handleClick = () => {
    if (!verifyTimeout) {
      withLoading(
        sendVerify(phone).then((res) => {
          if (!res.err) {
            ga.sendGAEvent(auth.userId, ga.GaEventType.SMS_CODE);
            setValue("verifyTimeout", moment().add(15, "minutes").unix());
            setValue("phoneVerifyStatus", verifyState.VERIFYING);
          } else {
            console.log(res.message);
            danger("發送簡訊失敗");
          }
        })
      );
    }
  };

  useEffect(() => {
    if (validPhone && phone === defaultValue) return;
    if (!verifyTimeout || moment(verifyTimeout * 1000).isBefore(moment())) {
      setValue("phoneVerifyStatus", verifyState.UNVERIFY);
      setValue("verifyTimeout", 0);
    }
  }, [phone]);

  const disabledButton =
    !validPhone ||
    status !== verifyState.UNVERIFY ||
    !phone.match(/^(09)[0-9]{8}$/) ||
    moment(verifyTimeout * 1000).isAfter(moment());

  return (
    <>
      <AnnotationItem
        annotation={item}
        helperText={verifyHelperText}
        error={isError}
        defaultValue={phone}
        // required={phone !== defaultValue}
        InputProps={{
          endAdornment: (
            <BlackButton
              variant="contained"
              sx={{
                "&.MuiButton-contained": { borderRadius: "8px" },
              }}
              color={isError ? "error" : undefined}
              disableElevation
              disabled={disabledButton}
              onClick={handleClick}
            >
              {status === verifyState.VERIFIED ? "已驗證" : "索取驗證碼"}
            </BlackButton>
          ),
        }}
      />
    </>
  );
}
